import StarRating from 'vue-star-rating'
import progressRing from '@/components/atoms/circle-progress/index.vue'


export default {
    name: 'action-plan-item',
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    components: {
        'circle-progress': progressRing,
        StarRating
    },
    data() {
        return {
            digitsVisible: false,
            radius: 15,
        }
    },
    computed: {
        progress() {
            return Math.round((100 / this.item.steps) * (this.item.userActionPlan.data.hasOwnProperty('completedSteps') ? this.item.userActionPlan.data.completedSteps : 0));
        },
        statusProgressItem() {
            if (!this.item.userActionPlan.data.hasOwnProperty('status') || this.item.userActionPlan.data.completedSteps === 0) return '';
            return this.item.userActionPlan.data.status
        }
    },
    created() {
        // this.progress = Math.round(this.item.lessons.data.current / this.item.lessons.data.total * 100);
    },
    methods: {
        declensionWord(count) {
            let titles = [this.$t('stepWord1'), this.$t('stepWord2'), this.$t('stepWord3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
    }
}
